<template>
  <div class="cover">
    <div class="policy-collapse">
      <div class="collapse-btn pointer" @click="isCollapse = !isCollapse">
        <b class="btn-title"
          >STUDIO <br />
          POLICY</b
        >
      </div>
      <div :class="{ 'content-wrap': true, 'active': isCollapse }">
        <div class="content">
          <div class="logo-wrap">
            STUDIO<br />
            POLICY
          </div>
          <div v-for="(item, index) in policyList" :key="index" class="policy-section">
            <b class="policy-title">{{ item.title }}</b>
            <b class="policy-desc">
              <span v-for="(seg, i) in parseContent(item.content)" :key="i" :class="{ green: seg.green }">{{ seg.text }}</span>
            </b>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPolicy } from '@/api/PolicyView'
export default {
  name: 'GlobalPolicy',
  data() {
    return {
      isCollapse: false,
      policyList: [],
    }
  },
  created() {
    getPolicy()
      .then((res) => {
        if (Array.isArray(res)) {
          this.policyList = res.filter((item) => item.active)
        }
      })
      .catch(() => {})
  },
  methods: {
    // Split content into segments; text wrapped in #...# renders green.
    parseContent(content) {
      if (!content) return []
      return content
        .split(/#([^#]+)#/)
        .map((text, i) => ({ text, green: i % 2 === 1 }))
        .filter((seg) => seg.text !== '')
    },
  },
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
